import React, { useState } from 'react';
import { Link, NavLink } from 'react-router-dom';
import './BrowseJobs.css';
import constructionWorkers from '../assets/construction-workers.webp';
import electrician from '../assets/electrician.webp';
import plumber from '../assets/plumber.webp';
import painter from '../assets/painter.jpg';
import carpenter from '../assets/carpenter.jpg';
import mason from '../assets/mason.jpg';
import welding from '../assets/welding.jpg';
import hvac from '../assets/hvac.jpg';
import scaffolding from '../assets/scaffolding.jpg';
import Navbar8 from './navbar8';
import { Fragment } from "react";
import Footer4 from './footer4';
import CTA26 from './cta26';

const sampleLabours = [
  {
    id: 1,
    name: 'Construction Workers Team',
    image: constructionWorkers,
    rating: 4.8,
    experience: '5+ years',
    skills: ['Masonry', 'Concrete Work', 'Scaffolding'],
    location: 'Mumbai',
    rate: '₹800/day',
    completedJobs: 45
  },
  {
    id: 2,
    name: 'Electrician Services',
    image: electrician,
    rating: 4.5,
    experience: '8+ years',
    skills: ['Wiring', 'Electrical Maintenance', 'Panel Installation'],
    location: 'Delhi',
    rate: '₹1200/day',
    completedJobs: 32
  },
  {
    id: 3,
    name: 'Plumbing Experts Team',
    image: plumber,
    rating: 4.5,
    experience: '8+ years',
    skills: ['Pipeline Installation', 'Leak Repair', 'Bathroom Fitting'],
    location: 'Bangalore',
    rate: '₹1,800/day',
    completedJobs: 65
  },
  {
    id: 4,
    name: 'Carpentry Specialists',
    image: carpenter,
    rating: 4.6,
    experience: '10+ years',
    skills: ['Furniture Making', 'Wood Carving', 'Interior Woodwork'],
    location: 'Chennai',
    rate: '₹1,200/day',
    completedJobs: 142
  },
  {
    id: 5,
    name: 'Painting Contractors',
    image: painter,
    rating: 4.3,
    experience: '6+ years',
    skills: ['Wall Painting', 'Texture Finishes', 'Waterproof Coating'],
    location: 'Hyderabad',
    rate: '₹900/day',
    completedJobs: 203
  },
  {
    id: 6,
    name: 'Masonry Professionals',
    image: mason,
    rating: 4.8,
    experience: '9+ years',
    skills: ['Brick Laying', 'Concrete Work', 'Floor Tiling'],
    location: 'Pune',
    rate: '₹1,100/day',
    completedJobs: 178
  },
  {
    id: 7,
    name: 'Welding Specialist',
    image: welding,
    rating: 4.4,
    experience: '7+ years',
    skills: ['ARC Welding', 'Metal Fabrication', 'Structural Welding'],
    location: 'Ahmedabad',
    rate: '₹1,600/day',
    completedJobs: 92
  },
  {
    id: 8,
    name: 'HVAC Technicians',
    image: hvac,
    rating: 4.7,
    experience: '11+ years',
    skills: ['AC Installation', 'Ventilation Systems', 'Maintenance'],
    location: 'Kolkata',
    rate: '₹1,750/day',
    completedJobs: 114
  },
  {
    id: 9,
    name: 'Scaffolding Experts',
    image: scaffolding,
    rating: 4.2,
    experience: '5+ years',
    skills: ['Temporary Structures', 'Safety Setup', 'Construction Support'],
    location: 'Surat',
    rate: '₹950/day',
    completedJobs: 85
  }
];

const BrowseJobs = () => {

  return (
    <>
      <Navbar8
              link1={
                <Link to="/home">
                  <span className="home-text100">Home</span>
                </Link>
              }
              link2={
                <Fragment>
                  <span className="home-text101">About Us</span>
                </Fragment>
              }
              link3={
                <Fragment>
                  <span className="home-text102">Contact</span>
                </Fragment>
              }
              link4={
                <Fragment>
                  <span className="home-text103">More</span>
                </Fragment>
              }
              page1={
                <Fragment>
                  <span className="home-text104">Home</span>
                </Fragment>
              }
              page2={
                <Fragment>
                  <span className="home-text105">About Us</span>
                </Fragment>
              }
              page3={
                <Fragment>
                  <span className="home-text106">Contact</span>
                </Fragment>
              }
              page4={
                <Fragment>
                  <span className="home-text107">More</span>
                </Fragment>
              }
              action1={
                <Fragment>
                  <span className="home-text109">Profile</span>
                </Fragment>
              }
              action2={
                <Link to="/login" className='nav-link'>
                  <span className="home-text109">Log In</span>
                </Link>
              }
              page1Description={
                <Fragment>
                  <span className="home-text110">
                    Welcome to our Platform homepage.
                  </span>
                </Fragment>
              }
              page2Description={
                <Fragment>
                  <span className="home-text111">
                    Fill out the form to post a job opening.
                  </span>
                </Fragment>
              }
              page3Description={
                <Fragment>
                  <span className="home-text112">
                    Manage your job postings and applications.
                  </span>
                </Fragment>
              }
              page4Description={
                <Fragment>
                  <span className="home-text113">
                    Sign in to access your account.
                  </span>
                </Fragment>
              }
      >
        
      </Navbar8>
      <CTA26
        action1={
          <Fragment>
            <span className="home-text124">Get Started</span>
          </Fragment>
        }
        content1={
          <Fragment>
            <span className="home-text125">
              Explore thousands of job opportunities and take the next step!
            </span>
          </Fragment>
        }
        heading1={
          <Fragment>
            <span className="home-text126">Find Your Dream Job Today</span>
          </Fragment>
        }
      ></CTA26>
      <div className="browse-jobs-container">
      <h1 className="browse-jobs-title">Available Work Opportunities</h1>
      
      <div className="search-filter-section">
        <input
          type="text"
          placeholder="Search by skills or location..."
          className="search-input"
        />
        <select className="filter-select">
          <option value="">All Categories</option>
          <option value="construction">Construction</option>
          <option value="electrical">Electrical</option>
          <option value="plumbing">Plumbing</option>
        </select>
      </div>

      <div className="jobs-grid">
        {sampleLabours.map((labour) => (
          <div key={labour.id} className="job-card">
            <div className="card-image">
              <img 
                src={labour.image}
                alt={labour.name}
                className="labour-image"
              />
            </div>
            <div className="card-header">
              <h3 className="labour-name">{labour.name}</h3>
              <div className="rating">
                {renderStars(labour.rating)}
                <span className="rating-number">({labour.rating})</span>
              </div>
            </div>
            
            <div className="card-body">
              <p className="experience">
                <span className="info-label">Experience:</span> {labour.experience}
              </p>
              <p className="location">
                <span className="info-label">Location:</span> {labour.location}
              </p>
              <div className="skills">
                {labour.skills.map((skill, index) => (
                  <span key={index} className="skill-tag">{skill}</span>
                ))}
              </div>
              <div className="rate-jobs">
                <span className="rate">{labour.rate}</span>
                <span className="completed-jobs">{labour.completedJobs} jobs completed</span>
              </div>
            </div>
            
            <div className="card-footer">
              <NavLink className="view-profile-btn" >View Profile</NavLink>
              <NavLink className="contact-btn" >Contact</NavLink>
            </div>
          </div>
        ))}
      </div>
      </div>
      <Footer4
              link1={
                <Link to="/home">
                  Home
                </Link>
              }
              link2={
                <Fragment>
                  <span className="home-text215">About Us</span>
                </Fragment>
              }
              link3={
                <Fragment>
                  <span className="home-text216">Contact Us</span>
                </Fragment>
              }
              link4={
                <Fragment>
                  <span className="home-text217">FAQ</span>
                </Fragment>
              }
              termsLink={
                <Fragment>
                  <span className="home-text219">Terms and Conditions</span>
                </Fragment>
              }
              cookiesLink={
                <Fragment>
                  <span className="home-text220">Cookies Policy</span>
                </Fragment>
              }
              privacyLink={
                <Fragment>
                  <span className="home-text221">Privacy Policy</span>
                </Fragment>
              }
      ></Footer4>
    </>
  );
};

const renderStars = (rating) => {
  const fullStars = Math.floor(rating);
  const hasHalfStar = rating % 1 >= 0.5;
  
  return (
    <div className="stars-container">
      {[...Array(fullStars)].map((_, i) => (
        <span key={i} className="star">★</span>
      ))}
      {hasHalfStar && <span className="star">½</span>}
      {[...Array(5 - fullStars - (hasHalfStar ? 1 : 0))].map((_, i) => (
        <span key={i + fullStars} className="star">☆</span>
      ))}
    </div>
  );
};

export default BrowseJobs;